import axios from "axios";
import moment from "moment";
import { jwtDecode } from "jwt-decode";
import userapiservice from "./userapiservice";
import { store } from "../Reducer/store";
import { setAccessToken } from "../Reducer/localStorageSlice";

const getCurrentTime = async () => {
  return new Promise(async (resolve, reject) => {
    const token = store?.getState()?.localStorage?.accessToken;
    const decoded = jwtDecode(token);
    const jwtExpTime = decoded?.exp;
    if (jwtExpTime) {
      const currentTime = moment().add(5, "minutes").unix();
      if (currentTime <= jwtExpTime) {
        resolve(true);
      } else {
        resolve(false);
      }
    } else {
      reject(false);
    }
  });
};

const getToken = async () => {
  try {
    const refreshToken = store?.getState()?.localStorage?.refresh;
    if (refreshToken) {
      const response = await fetch(userapiservice.refreshToken(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          refreshToken: refreshToken,
        }),
      });
      const dataR = await response.json();
      if (dataR) {
        store.dispatch(setAccessToken(dataR?.accessToken))
        return dataR.accessToken;
      }
    } else {
      console.log("refresh token not recived");
    }
  } catch (error) {
    console.error(error);
  }
};


axios.interceptors.request.use(
  async (req) => {
    const accessToken = store.getState()?.localStorage?.accessToken;
    if (accessToken) {
      const tokenExist = await getCurrentTime();
      if (tokenExist) {
        const token = accessToken;
        if (token) {
          req.headers.Authorization = `Bearer ${token}`;
        }
        return req;
      } else {
        const token = await getToken();
        if (token) {
          req.headers.Authorization = `Bearer ${token}`;
        }
        return req;
      }
    } else {
      return req;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const postRequest = async (url, data, headers) => {
  try {
    const response = await axios.post(url, data, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const putRequest = async (url, data, headers) => {
  try {
    const response = await axios.put(url, data, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const cache = new Map();
// using 5 mins as default before data is considered stale
const STALE_TIME = 5 * 60 * 1000;

export const getRequest = async (url, headers,dontForceRefresh=true) => {

  // Comment from a developer: Previously it was "forceRefresh" and below if has if(forceRefresh) - it was a mistake i guess
  // Now, i am changing it to "dontForceRefresh" and if(dontForceRefresh) then only it will check for cache and return cached data if not stale, otherwise it will make api call. 
  // If dontForceRefresh is false, then it will always make api call and update cache.
  // I have taken this decision just to avoid changing existing code where getRequest is being called without 3rd param, so by default it will check cache and return cached data if not stale, otherwise it will make api call.
  
  console.log('triggered getRequest',url, headers,dontForceRefresh);
  const cachedData = cache.get(encodeURI(url));
  if (dontForceRefresh && cachedData && Date.now() - cachedData.timestamp < STALE_TIME) {
    return Promise.resolve(cachedData.data);
  }

  try {
    const response = await axios.get(url, {
      headers: headers,
    });
    const data = response.data;

    // Store response in cache with timestamp
    // using encoded(url) so endpoints having params with " " will not be seen as new
    cache.set(encodeURI(url), { data, timestamp: Date.now() });
    return data;
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};

export const deleteRequest = async (url, data, headers) => {
  try {
    const response = await axios.delete(url, data, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const API_URL = process.env.REACT_APP_API_BASE_URL;
export const measurementId = process.env.REACT_APP_MEASUREMENT_ID;
